import View from 'views/base/view';
import utils from 'lib/utils';

const CssView = View.extend({
  autoRender: true,
  autoAttach: true,
  noWrap: true,
  initialize: function (options) {
    this.template = options.template;
    View.prototype.initialize.apply(this, arguments);
  },
  getTemplateFunction() {
    return utils.tryRequire(this.template);
  },
});

export default CssView;
